import React from 'react';
import { Layout } from '../components/layout/Layout';
import { BackButton } from '../components/BackButton';
import { ComingSoonCard } from '../components/ComingSoonCard';
import '../styles/dashboard.css';

export const QuickLearnPage = () => (
  <Layout>
    <div style={{ paddingTop: 40 }}>
      <BackButton />
      <ComingSoonCard
        title="Quick Learn"
        description="Rapid-fire learning mode with automatic card cycling, voice prompts, and personalized pacing — in development. Check back soon."
      />
    </div>
  </Layout>
);
